import React from 'react';
import './Footer.css';
import config from '../../config/config';

const NAV_ITEMS = [
  { id: 'home',     label: 'Home'     },
  { id: 'reviews',  label: 'Reviews'  },
  { id: 'howto',    label: 'How To'   },
  { id: 'faq',      label: 'FAQ'      },
  { id: 'contacts', label: 'Contacts' },
];

export default function Footer({ onNavigate }) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__brand-title">{config.SITE_TITLE}</div>
            <div className="footer__brand-tagline">{config.SITE_TAGLINE}</div>
          </div>

          {/* Navigation */}
          <div>
            <div className="footer__section-title">Explore</div>
            <nav className="footer__nav">
              {NAV_ITEMS.map(({ id, label }) => (
                <button key={id} className="footer__nav-link" onClick={() => onNavigate(id)}>
                  {label}
                </button>
              ))}
            </nav>
          </div>

          {/* Quick contact */}
          <div>
            <div className="footer__section-title">Find Us</div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon">📍</span>
              <span>{config.SITE_LOCATION}</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon">✉️</span>
              <span>{config.SITE_EMAIL}</span>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {year} {config.SITE_TITLE}. All rights reserved.
          </p>
          <p className="footer__tagline">Peaceful escapes by the sea.</p>
        </div>
      </div>
    </footer>
  );
}
